import Icon from 'components/Icon/Icon'
import Typography from 'components/Typography/Typography'
import FacebookLogin from 'react-facebook-login'
import { useIntl } from 'react-intl'

const HIDE_FACEBOOK_LOGIN = process.env.REACT_APP_HIDE_FACEBOOK_LOGIN

export default function FacebookLoginBtn({ onSuccess, onError }) {
    const intl = useIntl()

    const clientFbId = process.env.REACT_APP_FACEBOOK_ID

    if (HIDE_FACEBOOK_LOGIN === 'true') {
        return
    }

    return (
        <div className="facebook-login-wrapper">
            <FacebookLogin
                appId={clientFbId}
                fields="name,email,picture"
                callback={(resp) => onSuccess(resp)}
                onFailure={() => onError(variant)}
                cssClass={'button-social d-flex justify-content-center align-items-center w-100 bg-blueFacebook'}
                icon={<Icon name={'facebook'} />}
                disableMobileRedirect={true}
                textButton={
                    <Typography className={'ps-3'} variant={'buttonSocial'} color={'primary'}>
                        {intl.formatMessage(
                            { id: 'buttons.social' },
                            {
                                variant: 'Facebook',
                                spanCapitalize: (chunks) => <span className={'text-capitalize'}>{chunks}</span>,
                            }
                        )}
                    </Typography>
                }
            />
        </div>
    )
}
